import { DictionaryUUIDsEnum } from 'CorePackage/DictionariesModule/enums/DictionaryUUIDsEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IErknmAgreementExecution } from 'APIPackage/KnmModule/interfaces/IErknmAgreementExecution';
import { DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { convertInitialKnmDateToFormDate } from 'KnmPackage/MainModule/common/convertInitialKnmDateToFormDate';
import {
  failExecutionSelectOptions,
  successExecutionSelectOptions,
} from 'KnmPackage/MainModule/constants/agreementsExecutionSelectOptions';
import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

import { getSelectOption } from './getSelectOption';
import { IErknmFormAgreementExecution } from '../interfaces/IErknmFormAgreementExecution';

export const convertAgreementsExecutionToFormValues = (
  execution: IErknmAgreementExecution | null,
  state: IRootState,
): IErknmFormAgreementExecution | undefined => {
  if (!execution) {
    return undefined;
  }

  let decisionOption: ISelectOption<number> | undefined;

  if (execution.decision !== null) {
    decisionOption = execution.decision ? successExecutionSelectOptions : failExecutionSelectOptions;
  }

  return {
    decision: decisionOption,
    executionDate: convertInitialKnmDateToFormDate(
      execution.executionDate,
      DATE_FORMAT_LONG_FNS,
      SYSTEM_DATE_FORMAT_FNS,
    ),
    attachments: execution.attachments || undefined,
    fioSigner: execution.fioSigner || undefined,
    titleSigner: execution.titleSigner?.dictId
      ? getSelectOption<DictionaryUUIDsEnum.POSITIONS>(
          state,
          execution.titleSigner?.dictId,
          execution.titleSigner?.dictVersionId,
        )
      : undefined,
  };
};
